<!-- sob-modal-list.component.html -->
<div class="sob">
  <div class="sob__header">
    <h1 class="sob__header-title">Schedule of Benefits</h1>
    <span class="sob__header-sum">Sum Insured: {{ sobData.sumInsuredPerson | thousandsDot }}</span>
  </div>

  @for (group of groupedBenefits; track group.category) {
    <div class="sob__grid sob__grid--category">
      <div class="sob__category">
        {{ group.category }}
      </div>
    </div>

    @for (benefit of group.benefits; track benefit.id) {
      <div class="sob__grid sob__subgrid">
        <div class="sob__benefit">
          <div class="sob__benefit-name">
            {{ benefit.name }} {{ benefit.description }}
            @for (limit of benefit.limits; track limit.name) {
              <div class="sob__benefit-limit">
                <div class="sob__benefit-limit-name">- {{ limit.name }}</div>
                <div class="sob__benefit-limit-details">
                  {{ limit.amount | thousandsDot }}{{ limit | benefitValueType }} {{ limit.description || '' }}
                </div>
              </div>
            }


          </div>

        </div>
        <div class="sob__value" [class.sob__value--covered]="benefit.coverageType === 1">
          @if (benefit.coverageType === coverageType.PaidInFull) {
            ✔️
          } @else {
            {{ benefit.limitAmount | thousandsDot }}{{ benefit | benefitValueType }}
          }
        </div>
      </div>
    }
  }
</div>
